const getElement = (element, root = document) => {
  if (!element) return void 0;
  if (typeof element === "string") {
    if (typeof root === "undefined" || typeof document === "undefined") return void 0;
    const idElement = document.getElementById(element);
    return idElement ?? root.querySelector(element) ?? void 0;
  }
  return element.$el ?? element;
};
export {
  getElement as g
};
//# sourceMappingURL=getElement-WfnRgCbF.mjs.map
